var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{staticClass:"margins",attrs:{"separator":_vm.breadcrumb.font,"separator-class":_vm.breadcrumb.class}},_vm._l((_vm.breadcrumb.data),function(item,index){return _c('el-breadcrumb-item',{key:index,attrs:{"to":{ path: item.path },"replace":item.replace}},[_vm._v(_vm._s(item.label))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }